module.exports = __webpack_public_path__ + "img/hot_right_top.2395db08.png";